const locale = {
  availableIpCount: '个可用IP'
};
export default locale;